import React from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';

export default function FullWidthComponent({component}) {

  const {asPath, locale} = useRouter();
  const {t: translateCommon} = useTranslation('common');
  const {slug} = component.product;

  return <section className={'bg-black'}>
    <div style={{
      backgroundImage: `linear-gradient(rgba(33,33,33,0.61),rgba(33,33,33,0.61)),url(${
          component.product.extra[0].videoThumbnail.url})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundAttachment: 'fixed',
      backgroundPosition: 'center center',
    }} className={'h-full text-white'}>

      <div
          className={'w-3/4 lg:w-1/2 xl:w-1/3 ml-12 lg:ml-32 pt-12 h-48rem flex flex-col justify-center'}>
        <h2 className={'font-title text-3xl'}>
          {component.product.shortTitle}
        </h2>
        <p className={'pt-2 pb-10 font-light'}>
          {component.product.productDescription[0].content}
        </p>

        <div>
        <Link href={`/${locale}${asPath}/${slug}`}>
          <a className={'bg-gray-100 text-black font-medium rounded-4xl py-2 text-sm transition shadow-2xl hover:bg-gray-300 hover:shadow-2xl mb-12 px-5 transition-colors'}>
            {translateCommon('MORE_ABOUT')}
          </a>
        </Link>
        </div>
      </div>
    </div>
  </section>;

}